module.exports = __webpack_public_path__ + "static/media/landing.ca58990e.png";